import { Col, Container, Row } from 'react-grid-system'
import styled from 'styled-components'
import colors from '../assets/colors/colors'
import Header from '../components/layout/Header'

import {
    GoVerified
} from 'react-icons/go'


interface StyledInterface {
    color: any
}
export default function Business() {
    return (
        <>
            <Header />
            <Content color={colors}>
                <Container>
                    <header>
                        <h1>
                            Bienvenidos al hogar de los <span>menus digitales</span>
                        </h1>
                        <p>
                            Aqui encontraras los menus digital que estan disponible en
                            nuestra plataforma.
                        </p>
                    </header>
                    <main>
                        <div className="card_ my-4">
                            <Row align='center'>
                                <Col xs={4} md={2}>
                                    <div className="logo">
                                        <img src="https://firebasestorage.googleapis.com/v0/b/digitalmenu-e82c4.appspot.com/o/upload_images%2Fb98424df-04b9-40ef-b25e-480f1a1f78b8?alt=media" alt="" />
                                    </div>
                                </Col>
                                <Col>
                                    <h5>Na' Popi</h5>
                                    <p>Un ambiente diferente.</p>
                                </Col>
                            </Row>
                        </div>
                        <div className="card_ my-4">
                            <Row align='center'>
                                <Col xs={4} md={2}>
                                    <div className="logo">
                                        <img src="https://firebasestorage.googleapis.com/v0/b/digitalmenu-e82c4.appspot.com/o/upload_images%2Fb98424df-04b9-40ef-b25e-480f1a1f78b8?alt=media" alt="" />
                                    </div>
                                </Col>
                                <Col>
                                    <h5>Na' Popi</h5>
                                    <p>Un ambiente diferente.</p>
                                </Col>
                            </Row>
                        </div>
                        <div className="card_ my-4">
                            <Row align='center'>
                                <Col xs={4} md={2}>
                                    <div className="logo">
                                        <img src="https://firebasestorage.googleapis.com/v0/b/digitalmenu-e82c4.appspot.com/o/upload_images%2Fb98424df-04b9-40ef-b25e-480f1a1f78b8?alt=media" alt="" />
                                    </div>
                                </Col>
                                <Col>
                                    <h5>Na' Popi</h5>
                                    <p>Un ambiente diferente.</p>
                                </Col>
                            </Row>
                        </div>
                    </main>
                </Container>
            </Content>
        </>
    )
}

const Content = styled.div<StyledInterface>`
    min-height: 100vh;
    header {
        width: 100%;
        height: 30vh;
        display: flex;
        flex-direction: column;
        justify-content:center;
        align-items:center;
        text-align:center;
    }
    span {
        color: ${props => props.color.violet};
    }
    h1 {
            font-size: 2.1em;
            font-weight: 900;
            color: ${props => props.color.black};
        }
    p {
        color:  ${props => props.color.black2};
        font-size: 1em;
        font-weight: 600;
    }
    .card_ {
        width: 100%;
        background:white;
        border: 2px solid ${props => props.color.white01};
        border-radius: 8px;
        padding: 1em;
        color: ${props => props.color.black};
        .logo {
            width: 100%;
            text-align:center;
            padding: 1em;
            img {
                width: 80px;
                height: 80px;
                border-radius: 6px;
            }
        }
        h5 {
            color: ${props => props.color.black};
            font-weight: 700;
        }
        p {
            font-size: 0.8em;
        }
        .stars{
            color: #fc5151;
            font-size: 1.5em;
            letter-spacing: 0.2em;
        }
    }
`
